<template>
    <main class="max-width-container">
        <h1 class="form-title">Add bucket list</h1>
        <BucketListForm
            v-if="!loading"
            back-link="/bucket-lists"
            :errors="errors"
            :templates="templates"
            @submit-form="submitForm"
            @clear-error="clearError"
        />
    </main>
</template>

<script>
import BucketListForm from "js/components/forms/BucketListForm";
import BaseFormWrapper from "js/components/base/BaseFormWrapper.js";
import { useBucketListStore } from "js/stores/bucketListStore";

export default {
    name: "BucketListAdd",
    components: {
        BucketListForm,
    },
    extends: BaseFormWrapper,
    data() {
        return {
            store: undefined,
            loading: true,
            templates: [],
        };
    },
    mounted() {
        this.store = useBucketListStore();
        this.store.fetch("/api/help/bucket-lists").then((data) => {
            this.templates = data.templates;
            this.loading = false;
        });
    },
    methods: {
        submitForm(data) {
            this.store
                .create("/api/bucket-lists?with-items", data)
                .then((bl) => {
                    this.store.add(bl);
                    this.$router.push(`/bucket-lists/${bl.id}`);
                })
                .catch(this.handleResponseErrors);
        },
    },
};
</script>
